export const CACHE_KEY_LIST_NOMENCLATURES_TEMPLATES_CATEGORY = 'nomenclatures-templates-category';
export const CACHE_KEY_NOMENCLATURES_TEMPLATES_CATEGORY = 'nomenclatures-templates-category-one';
export const ROUTE_PATH_NOMENCLATURES_TEMPLATES_CATEGORY = '/settings/nomenclatures/templates-category';
export const TRANSLATION_PREFIX_NOMENCLATURES_TEMPLATES_CATEGORY = 'nomenclaturesTemplatesCategory';

